var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16663 3.74996C3.16663 3.42779 3.42779 3.16663 3.74996 3.16663H8.99754C9.31971 3.16663 9.58087 3.42779 9.58087 3.74996C9.58087 4.07213 9.31971 4.33329 8.99754 4.33329H4.33329V13.6666H8.99996C9.32213 13.6666 9.58329 13.9278 9.58329 14.25C9.58329 14.5721 9.32213 14.8333 8.99996 14.8333H3.74996C3.42779 14.8333 3.16663 14.5721 3.16663 14.25V3.74996ZM11.2125 5.96248C11.4403 5.73467 11.8096 5.73467 12.0374 5.96248L14.6296 8.5546C14.7543 8.66158 14.8333 8.82033 14.8333 8.99754C14.8333 8.99787 14.8333 8.99819 14.8333 8.99852C14.8337 9.14829 14.7767 9.29817 14.6624 9.41244L12.0374 12.0374C11.8096 12.2652 11.4403 12.2652 11.2125 12.0374C10.9847 11.8096 10.9847 11.4403 11.2125 11.2125L12.8441 9.58087H6.66663C6.34446 9.58087 6.08329 9.31971 6.08329 8.99754C6.08329 8.67537 6.34446 8.41421 6.66663 8.41421H12.8392L11.2125 6.78744C10.9847 6.55963 10.9847 6.19029 11.2125 5.96248Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.3c5199d8f20947ac5da48b8ab331f549.svg";
export { ForwardRef as ReactComponent };